import {CheatSettingsController, CheatSettingsController as Controller} from './CheatSettingsController';
import {CheatSettingsView as View} from './CheatSettingsView';
import {CheatPlugin} from '../../CheatModuleInterfaces';

const settings: CheatPlugin = {
    name: 'Settings',
    init: () => [
        Controller,
        View
    ]
};

const SpecialWinTypeConfig = {
    minWinToBetRatio: 0,
    maxWinToBetRatio: 1,
    name: 'SpecialWinType',
    sounds: ['winSingle'],
    duration: 1,
    noCountUpAnimation: true
};

CheatSettingsController.addSettingAction({
    id: 'enableSpecialWinType',
    apply: settings => settings.set('specialWinTypeConfig', SpecialWinTypeConfig),
    reject: settings => settings.set('specialWinTypeConfig', undefined)
});

export default settings;
